/**
 * 隐患上报闭环管理看板 — POST /api/produce/kanban/safety-hazard-closed-loop-board
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/safety-hazard-closed-loop-board'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @param {object} params 可选 startTime、endTime（毫秒）、limit
 * @returns {Promise<{ list: array }>}
 */
export function fetchSafetyHazardClosedLoopBoard(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
